// src/components/providers/ground-transportation-criteria-provider.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query PropertySearchQuery(\n    $context: ContextInput!\n    $destination: DestinationInput!\n    $rooms: [RoomInput!]\n    $dateRange: PropertyDateRangeInput\n    $sort: PropertySort\n    $filters: PropertySearchFiltersInput\n    $marketing: PropertyMarketingInfoInput\n    $propertyShopOptions: PropertyShopOptionsInput\n    $searchPagination: PaginationInput\n    $searchIntent: SearchIntentInput\n    $shoppingContext: ShoppingContextInput\n    $criteria: PropertySearchCriteriaInput\n    $productShoppingCriteriaInput: ProductShoppingCriteriaInput\n  ) {\n    propertySearch(\n      context: $context\n      destination: $destination\n      rooms: $rooms\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      marketing: $marketing\n      propertyShopOptions: $propertyShopOptions\n      searchPagination: $searchPagination\n      searchIntent: $searchIntent\n      shoppingContext: $shoppingContext\n      criteria: $criteria\n      productShoppingCriteriaInput: $productShoppingCriteriaInput\n      returnPropertyType: false\n    ) {\n      searchCriteria {\n        searchId\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { useLocation } from "react-router-dom";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLocalization } from "@shared-ui/localization-context";
// src/utils/date-utils.ts
var isoDateToDateInput = function(dateString) {
    var _dateString_split_map = _sliced_to_array(dateString.split("-").map(function(datePart) {
        return Number.parseInt(datePart, 10);
    }), 3), year = _dateString_split_map[0], month = _dateString_split_map[1], day = _dateString_split_map[2];
    return {
        day: day,
        month: month,
        year: year
    };
};
var formatDateStringToIsoDate = function(dateString, localDateFormat, l10n) {
    var localDate;
    try {
        localDate = l10n.parseLocalDateString(dateString, {
            raw: localDateFormat
        });
    } catch (localDateFormatParseError) {
        try {
            localDate = l10n.parseLocalDateString(dateString, {
                raw: "yyyy-MM-dd"
            });
        } catch (isoDateFormatParseError) {
            return null;
        }
    }
    var cleanDate = l10n.formatDate(localDate, {
        raw: "yyyy-MM-dd"
    });
    return cleanDate || null;
};
// src/utils/ground-transportation-query-params.ts
var DEFAULT_TIME = "10:30";
var SHOP_WITH_POINTS = "swp";
var SORT = "sort";
var FILTER = "filter";
function getSearchDirection(roundTrip, direction) {
    if (roundTrip === "true") {
        return "ROUNDTRIP" /* ROUNDTRIP */ ;
    }
    switch(direction){
        case "H2A":
        case "TO_AIRPORT" /* TO_AIRPORT */ :
            return "TO_AIRPORT" /* TO_AIRPORT */ ;
        default:
            return "FROM_AIRPORT" /* FROM_AIRPORT */ ;
    }
}
function getCoordinates(latLong) {
    if (!latLong) {
        return null;
    }
    var _latLong_split = _sliced_to_array(latLong.split(","), 2), latitude = _latLong_split[0], longitude = _latLong_split[1];
    return latitude && longitude ? {
        latitude: Number(latitude),
        longitude: Number(longitude)
    } : null;
}
var getDefaultDate = function() {
    var defaultTimeStamp = /* @__PURE__ */ new Date();
    defaultTimeStamp.setDate(defaultTimeStamp.getDate() + 14);
    return defaultTimeStamp.toISOString().split("T")[0];
};
var getTimeTuple = function(timeStrParam) {
    var timeStr = timeStrParam !== null && timeStrParam !== void 0 ? timeStrParam : DEFAULT_TIME;
    var _timeStr_split_map = _sliced_to_array(timeStr.split(":").map(function(val) {
        return parseInt(val, 10);
    }), 2), hour = _timeStr_split_map[0], minute = _timeStr_split_map[1];
    return [
        !Number.isNaN(hour) ? hour : 10,
        minute !== void 0 && !Number.isNaN(minute) ? minute : 30
    ];
};
function getDateTimeInput(dateStr, timeStr, localDateFormat, l10n) {
    var isoDate = formatDateStringToIsoDate(dateStr !== null && dateStr !== void 0 ? dateStr : getDefaultDate(), localDateFormat, l10n);
    var dateObj = isoDateToDateInput(isoDate !== null && isoDate !== void 0 ? isoDate : getDefaultDate());
    var _getTimeTuple = _sliced_to_array(getTimeTuple(timeStr), 2), hour = _getTimeTuple[0], minute = _getTimeTuple[1];
    return _object_spread_props(_object_spread({}, dateObj), {
        hour: hour,
        minute: minute,
        second: 0
    });
}
function getHotelData(urlParams) {
    var hotelId = urlParams.hotelId, hotelName = urlParams.hotelName, hotelLatLong = urlParams.hotelLatLong;
    return {
        id: hotelId,
        name: hotelName,
        coordinates: getCoordinates(hotelLatLong),
        type: "PROPERTY" /* PROPERTY */ 
    };
}
function getAirportData(urlParams) {
    var airportCode = urlParams.airportCode, location = urlParams.location, airportLatLong = urlParams.airportLatLong, regionId = urlParams.regionId;
    return airportCode ? {
        id: airportCode,
        name: location,
        coordinates: getCoordinates(airportLatLong),
        type: "AIRPORT" /* AIRPORT */ 
    } : {
        id: regionId,
        name: location,
        type: "DESTINATION" /* DESTINATION */ 
    };
}
function getTravelersDetails(urlParams) {
    var adults = urlParams.adults, children = urlParams.children, infants = urlParams.infants;
    var travelerDetails = [];
    if (adults) {
        travelerDetails.push({
            type: "ADULT" /* ADULT */ ,
            count: parseInt(adults, 10)
        });
    }
    if (children) {
        travelerDetails.push({
            type: "CHILD" /* CHILD */ ,
            count: parseInt(children, 10)
        });
    }
    if (infants) {
        travelerDetails.push({
            type: "INFANT" /* INFANT */ ,
            count: parseInt(infants, 10)
        });
    }
    return travelerDetails;
}
function getPrimarySearchCriteria(urlSearchParams, localDateFormat, l10n) {
    var _primaryCriteria_journeyCriteria;
    var primaryCriteria = {
        journeyCriteria: [],
        shoppingPath: "STANDALONE" /* STANDALONE */ ,
        travelerDetails: [],
        dateRange: {},
        // deprecated
        direction: "FROM_AIRPORT" /* FROM_AIRPORT */ ,
        // deprecated
        locations: []
    };
    var urlParams = Object.fromEntries(urlSearchParams);
    var direction = urlParams.direction, roundTrip = urlParams.roundTrip, pickUpDate = urlParams.pickUpDate, pickUpTime = urlParams.pickUpTime, dropOffDate = urlParams.dropOffDate, dropOffTime = urlParams.dropOffTime;
    var searchDirection = getSearchDirection(roundTrip, direction);
    var toAirport = searchDirection === "TO_AIRPORT" /* TO_AIRPORT */ ;
    var onwardJourney = {
        dateTime: getDateTimeInput(pickUpDate, pickUpTime, localDateFormat, l10n),
        origin: toAirport ? getHotelData(urlParams) : getAirportData(urlParams),
        destination: toAirport ? getAirportData(urlParams) : getHotelData(urlParams)
    };
    (_primaryCriteria_journeyCriteria = primaryCriteria.journeyCriteria) === null || _primaryCriteria_journeyCriteria === void 0 ? void 0 : _primaryCriteria_journeyCriteria.push(onwardJourney);
    if (urlParams.roundTrip === "true") {
        var _primaryCriteria_journeyCriteria1;
        var departureDate = dropOffDate !== null && dropOffDate !== void 0 ? dropOffDate : pickUpDate;
        var departureTime = dropOffTime !== null && dropOffTime !== void 0 ? dropOffTime : pickUpTime;
        var returnJourney = {
            dateTime: getDateTimeInput(departureDate, departureTime, localDateFormat, l10n),
            origin: getHotelData(urlParams),
            destination: getAirportData(urlParams)
        };
        (_primaryCriteria_journeyCriteria1 = primaryCriteria.journeyCriteria) === null || _primaryCriteria_journeyCriteria1 === void 0 ? void 0 : _primaryCriteria_journeyCriteria1.push(returnJourney);
    }
    primaryCriteria.travelerDetails = getTravelersDetails(urlParams);
    return primaryCriteria;
}
var getAllKeysWithKeyword = function(keyword, urlParams, query) {
    var mergedQueryObject = query ? _object_spread({}, query, urlParams) : _object_spread({}, urlParams);
    return Object.keys(mergedQueryObject).filter(function(key) {
        return key.indexOf(keyword) > -1;
    });
};
var getSelections = function(urlParams) {
    if (Object.keys(urlParams).length === 0) {
        return null;
    }
    var selections = [];
    var allFilterKeys = getAllKeysWithKeyword(FILTER, urlParams);
    var _urlParams_sort;
    selections.push({
        id: SORT,
        value: (_urlParams_sort = urlParams.sort) !== null && _urlParams_sort !== void 0 ? _urlParams_sort : ""
    });
    allFilterKeys.forEach(function(key) {
        var values = urlParams[key] ? urlParams[key].split(",") : null;
        if (values) {
            values.forEach(function(value) {
                if (value) {
                    selections.push({
                        id: key,
                        value: value
                    });
                }
            });
        }
    });
    return selections;
};
var getSecondarySearchCriteria = function(urlSearchParams) {
    var urlParams = Object.fromEntries(urlSearchParams);
    return {
        booleans: [
            {
                id: SHOP_WITH_POINTS,
                value: urlParams[SHOP_WITH_POINTS] !== "false"
            }
        ],
        selections: getSelections(urlParams)
    };
};
// src/components/providers/ground-transportation-criteria-provider.tsx
var GroundTransportationCriteriaContext = React.createContext([
    null,
    null
]);
var useGroundTransportationCriteria = function() {
    return React.useContext(GroundTransportationCriteriaContext);
};
var GroundTransportationCriteriaProvider = function(param) {
    var children = param.children;
    var l10n = useLocalization();
    var context = useBexApi().context;
    var location = useLocation();
    var groundTransportationCriteriaContextValue = React.useMemo(function() {
        var urlSearchParams = new URLSearchParams(location.search);
        var primaryGroundTransportationCriteria = getPrimarySearchCriteria(urlSearchParams, context.locale, l10n);
        var secondaryCriteria = getSecondarySearchCriteria(urlSearchParams);
        return [
            primaryGroundTransportationCriteria,
            secondaryCriteria
        ];
    }, [
        location.search,
        context.locale,
        l10n
    ]);
    return /* @__PURE__ */ React.createElement(GroundTransportationCriteriaContext.Provider, {
        value: groundTransportationCriteriaContextValue
    }, children);
};
GroundTransportationCriteriaProvider.displayName = "GroundTransportationCriteriaProvider";
// src/components/providers/product-shopping-criteria-provider.tsx
import React2 from "react";
import { gql } from "@apollo/client";
var __PropertySearchQuery = gql(_templateObject());
var ProductShoppingCriteriaContext = React2.createContext(null);
var useProductShoppingCriteria = function() {
    return React2.useContext(ProductShoppingCriteriaContext);
};
var ProductType = /* @__PURE__ */ function(ProductType2) {
    ProductType2["groundTransportation"] = "GROUND_TRANSPORTATION";
    return ProductType2;
}(ProductType || {});
var productShoppingCriteriaProviderMap = _define_property({}, "GROUND_TRANSPORTATION" /* groundTransportation */ , GroundTransportationCriteriaProvider);
var ProductShoppingCriteriaConsumer = function(param) {
    var children = param.children;
    var _useGroundTransportationCriteria = _sliced_to_array(useGroundTransportationCriteria(), 2), primaryGroundTransportationCriteria = _useGroundTransportationCriteria[0], secondaryCriteria = _useGroundTransportationCriteria[1];
    var productShoppingCriteria = React2.useMemo(function() {
        return {
            primarySearchCriteria: {
                groundTransportation: primaryGroundTransportationCriteria
            },
            secondaryCriteria: secondaryCriteria
        };
    }, [
        primaryGroundTransportationCriteria,
        secondaryCriteria
    ]);
    return /* @__PURE__ */ React2.createElement(ProductShoppingCriteriaContext.Provider, {
        value: productShoppingCriteria
    }, children);
};
var ProductShoppingCriteriaProvider = function(param) {
    var children = param.children, productType = param.productType;
    var ShoppingCriteriaProvider = productShoppingCriteriaProviderMap[productType];
    return /* @__PURE__ */ React2.createElement(ShoppingCriteriaProvider, null, /* @__PURE__ */ React2.createElement(ProductShoppingCriteriaConsumer, null, children));
};
ProductShoppingCriteriaProvider.displayName = "ProductShoppingCriteriaProvider";
export { GroundTransportationCriteriaProvider, ProductShoppingCriteriaProvider, ProductType, useGroundTransportationCriteria, useProductShoppingCriteria };
//# sourceMappingURL=index.js.map